<template>
  <div class="mt-3 mb-2"> 
    <h5 class="mb-2">{{ label }}</h5>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'labeled-text',
  props: {
    label: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/base/ui/LabeledText.vue